import { render, staticRenderFns } from "./ContactProfoleEdition.vue?vue&type=template&id=371f4679&scoped=true&lang=pug&"
import script from "./ContactProfoleEdition.vue?vue&type=script&lang=js&"
export * from "./ContactProfoleEdition.vue?vue&type=script&lang=js&"
import style0 from "./ContactProfoleEdition.vue?vue&type=style&index=0&id=371f4679&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f4679",
  null
  
)

export default component.exports